import type { BugReporterService } from "../types";

export class NoopService implements BugReporterService {
  report() {}

  reportGlobalTags() {}

  reportIdentify() {}

  reportInit() {}
}
